import { Component, input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './back-button.html',
})
export class BackButtonComponent {
  constructor(
    private router: Router,
    private location: Location,
  ) {}

  route = input<string>('');

  goBack() {
    this.route() ? this.router.navigate([this.route()]) : this.location.back();
  }
}
